package br.com.heyagenda.domain.usecase

import br.com.heyagenda.domain.model.DayOff
import br.com.heyagenda.domain.repository.AvailabilityRepository

class AddDayOffUseCase(
    private val repository: AvailabilityRepository
) {
    suspend operator fun invoke(dayOff: DayOff): Result<Unit> {
        if (dayOff.dateIso.isBlank()) {
            return Result.failure(IllegalArgumentException("A data da folga é obrigatória."))
        }
        return repository.addDayOff(dayOff)
    }
}
